import { render, staticRenderFns } from "./whBoProductname.vue?vue&type=template&id=4cb8eaaf&scoped=true&"
import script from "./whBoProductname.vue?vue&type=script&lang=js&"
export * from "./whBoProductname.vue?vue&type=script&lang=js&"
import style0 from "./whBoProductname.vue?vue&type=style&index=0&id=4cb8eaaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb8eaaf",
  null
  
)

export default component.exports